<template>
  <div class="breadcrumb_text d-none d-md-block ">
    <span class="text-uppercase">
      <a href="/">{{$t('home.home')}}</a>
      /
    </span>
    <span class="text-uppercase" style="text-transform:Capitalize;">{{title}}</span>
  </div>
</template>

<script>
export default {
  props: ["title"]
};
</script>

<style lang="scss" scoped>
.breadcrumb_text {
  margin: 28px 0 12px 0;
  font-size: 12px;
  a {
    color: #5f4ae2;
  }
}
</style>
